module.exports = __webpack_public_path__ + "static/media/gothaer_logo.6295eef8.png";